<!-- Zweck: Stellt die HTML-Struktur für shop view filter menu component ts im Frontend bereit. -->
@if (filter.children && filter.children.length > 0) {
  <button (menuClosed)="this.open = false" (menuOpened)="this.open = true" [matMenuTriggerFor]="filterMenu"
    class="shop-view-filter-menu"
    mat-button>
    <table>
      <td style="width: 1%">
        <mat-checkbox [class.bordered]="filter.active_children && filter.active_children > 0" (change)="doChangeAll()" (click)="$event.stopPropagation()"
        [(ngModel)]="filter.active"></mat-checkbox>
      </td>
      <td (click)="clickFilter(filter, $event)">
        {{ filter.label }}
      </td>
      <td>
        @if (open) {
          <svg-icon>mehr</svg-icon>
        }
        @if (!open) {
          <svg-icon>weniger</svg-icon>
        }
      </td>
    </table>
  </button>
  <mat-menu #filterMenu="matMenu">
    @for (c of filter.children; track c) {
      <button mat-menu-item
        [matMenuTriggerFor]="c.children.length > 0 ? childMenuLV1 : null" [matMenuTriggerData]="{filter: c}">
        <table>
          <td style="width: 1%">
            <div class="checkboxbox" (click)="markFilter($event, elem)">
              <mat-checkbox #elem [class.bordered]="c.active_children && c.active_children > 0" (change)="doChange(c)" (click)="$event.stopPropagation()"
              [(ngModel)]="c.active"></mat-checkbox>
            </div>
          </td>
          <td (click)="clickFilter(c, $event)">
            {{ c.label }}
          </td>
        </table>
      </button>
    }
  </mat-menu>
  <mat-menu #childMenuLV1="matMenu">
    <ng-template matMenuContent let-filter="filter">
      @for (c of filter.children; track c) {
        <button mat-menu-item class="mat-menu-item"
          [matMenuTriggerFor]="c.children.length > 0 ? childMenuLV2 : null" [matMenuTriggerData]="{filter: c}">
          <table>
            <td style="width: 1%">
              <div class="checkboxbox" (click)="markFilter($event, elem)">
                <mat-checkbox #elem  [class.bordered]="c.active_children && c.active_children > 0" (change)="doChange(c)" (click)="$event.stopPropagation()"
                [(ngModel)]="c.active"></mat-checkbox>
              </div>
            </td>
            <td (click)="clickFilter(c, $event)">
              {{ c.label }}
            </td>
          </table>
        </button>
      }
    </ng-template>
  </mat-menu>
  <mat-menu #childMenuLV2="matMenu">
    <ng-template matMenuContent let-filter="filter">
      @for (c of filter.children; track c) {
        <button mat-menu-item class="mat-menu-item"
          [matMenuTriggerFor]="c.children.length > 0 ? childMenuLV3 : null" [matMenuTriggerData]="{filter: c}">
          <table>
            <td style="width: 1%">
              <div class="checkboxbox" (click)="markFilter($event, elem)">
                <mat-checkbox #elem  [class.bordered]="c.active_children && c.active_children > 0" (change)="doChange(c)" (click)="$event.stopPropagation()"
                [(ngModel)]="c.active"></mat-checkbox>
              </div>
            </td>
            <td (click)="clickFilter(c, $event)">
              {{ c.label }}
            </td>
          </table>
        </button>
      }
    </ng-template>
  </mat-menu>
  <mat-menu #childMenuLV3="matMenu">
    <ng-template matMenuContent let-filter="filter">
      @for (c of filter.children; track c) {
        <button mat-menu-item class="mat-menu-item"
          [matMenuTriggerFor]="c.children.length > 0 ? childMenuLV4 : null" [matMenuTriggerData]="{filter: c}">
          <table>
            <td style="width: 1%">
              <div class="checkboxbox" (click)="markFilter($event, elem)">
                <mat-checkbox #elem  [class.bordered]="c.active_children && c.active_children > 0" (change)="doChange(c)" (click)="$event.stopPropagation()"
                [(ngModel)]="c.active"></mat-checkbox>
              </div>
            </td>
            <td (click)="clickFilter(c, $event)">
              {{ c.label }}
            </td>
          </table>
        </button>
      }
    </ng-template>
  </mat-menu>
  <mat-menu #childMenuLV4="matMenu">
    <ng-template matMenuContent let-filter="filter">
      @for (c of filter.children; track c) {
        <button mat-menu-item class="mat-menu-item">
          <table>
            <td style="width: 1%">
              <div class="checkboxbox" (click)="markFilter($event, elem)">
                <mat-checkbox #elem  [class.bordered]="c.active_children && c.active_children > 0" (change)="doChange(c)" (click)="$event.stopPropagation()"
                [(ngModel)]="c.active"></mat-checkbox>
              </div>
            </td>
            <td (click)="clickFilter(c, $event)">
              {{ c.label }}
            </td>
          </table>
        </button>
      }
    </ng-template>
  </mat-menu>
}

@if (!filter.children || (filter.children && filter.children.length == 0)) {
  <button class="shop-view-filter-menu"
    mat-button (click)="toggle()">
    <table>
      <td style="width: 1%">
        <mat-checkbox (change)="doChangeAll()" (click)="$event.stopPropagation()"
        [(ngModel)]="filter.active"></mat-checkbox>
      </td>
      <td>
        {{ filter.label }}
      </td>
    </table>
  </button>
}
